import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="App">
      <Header />
      <main style={{ padding: "120px 24px 80px", maxWidth: "800px", margin: "0 auto", fontFamily: "'Lato', sans-serif", color: "var(--text-primary)", lineHeight: "1.8" }}>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "2.5rem", marginBottom: "8px" }}>Privacy Policy</h1>
        <p style={{ color: "var(--text-muted)", marginBottom: "48px" }}>Last updated: May 6, 2026</p>

        <section style={{ marginBottom: "40px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", marginBottom: "12px" }}>1. Who We Are</h2>
          <p>Villa in Pietra is a private vacation rental located at Bajkini 6F, 52447 Bajkini, Istria, Croatia. For any privacy-related inquiries, you may contact us via WhatsApp at <strong>+385 91 622 7421</strong>.</p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", marginBottom: "12px" }}>2. What Data We Collect</h2>
          <p>When you visit our website or contact us, we may collect:</p>
          <ul style={{ paddingLeft: "24px", marginTop: "12px" }}>
            <li>Name and contact information (phone number or email) — only when you voluntarily submit a booking inquiry</li>
            <li>Usage data via Google Analytics 4 (anonymous, aggregated)</li>
            <li>Session data via PostHog (anonymous usage analytics)</li>
            <li>Your cookie consent preference (stored in your browser's localStorage)</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", marginBottom: "12px" }}>3. How We Use Your Data</h2>
          <ul style={{ paddingLeft: "24px" }}>
            <li>To respond to your booking inquiry and provide a personalized quote</li>
            <li>To improve our website based on anonymous usage statistics</li>
            <li>We do not sell or share your personal data with third parties</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", marginBottom: "12px" }}>4. Cookies</h2>
          <p>We use the following cookies and tracking technologies:</p>
          <ul style={{ paddingLeft: "24px", marginTop: "12px" }}>
            <li><strong>Google Analytics 4</strong> — anonymous traffic analysis (can be disabled by declining cookies)</li>
            <li><strong>PostHog</strong> — anonymous session analytics</li>
            <li><strong>localStorage (cookie_consent)</strong> — remembers your cookie preference</li>
            <li><strong>localStorage (villa-lang)</strong> — remembers your selected language</li>
          </ul>
          <p style={{ marginTop: "12px" }}>You can withdraw your consent at any time by clearing your browser's localStorage and cookies.</p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", marginBottom: "12px" }}>5. Your Rights (GDPR)</h2>
          <p>Under the General Data Protection Regulation (GDPR), you have the right to:</p>
          <ul style={{ paddingLeft: "24px", marginTop: "12px" }}>
            <li>Access the personal data we hold about you</li>
            <li>Request correction or deletion of your data</li>
            <li>Object to or restrict processing of your data</li>
            <li>Data portability</li>
          </ul>
          <p style={{ marginTop: "12px" }}>To exercise any of these rights, contact us via WhatsApp: <strong>+385 91 622 7421</strong></p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", marginBottom: "12px" }}>6. Data Retention</h2>
          <p>Booking inquiry data (name and contact) is retained only as long as necessary to handle your request, and no longer than 12 months. Anonymous analytics data is retained according to the respective platform's policies (Google Analytics: 14 months).</p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.5rem", marginBottom: "12px" }}>7. Changes to This Policy</h2>
          <p>We may update this policy occasionally. The latest version will always be available at <strong>villainpietra.eu/privacy-policy</strong>.</p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
